export function CheckboxCheckedDisabledIcon({ className }: { className?: string }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g opacity="0.5">
        <rect x="1" y="1" width="18" height="18" rx="4" fill="#101828" />
        <path d="M14.1658 6.875L8.43668 12.6042L5.83252 10" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
      </g>
    </svg>
  );
}

export const displayName = "CheckboxCheckedDisabledIcon";
